import { render, staticRenderFns } from "./Navi.vue?vue&type=template&id=b3b81d9e&scoped=true&lang=pug&"
import script from "./Navi.vue?vue&type=script&lang=js&"
export * from "./Navi.vue?vue&type=script&lang=js&"
import style0 from "./Navi.vue?vue&type=style&index=0&id=b3b81d9e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3b81d9e",
  null
  
)

export default component.exports